import React, { useState } from 'react';
import { Button, usePrompt } from '../../ui';
import { Copy, Flexer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { TeamLocationSelectView } from './TeamLocationSelectView';

export type TeamLocationSelectPopupProps = {
    mode: 'user' | 'admin',
    title?: string,
    label?: string,
    primary?: string,
};

export const teamLocationSelectPopup = (args: TeamLocationSelectPopupProps) => ({ ui: TeamLocationSelectPopup, args });

export const TeamLocationSelectPopup = React.memo(({ action, dismiss, args }: PopupProps) => {
    const { mode, title, label, primary } = args as TeamLocationSelectPopupProps;

    const [location, setLocation] = useState(null as { workspaceId: string, folderId?: string } | null);
    const invalid = !location;

    const onAction = (confirm: boolean) => {
        if (confirm && location) {
            action(location);
        }
        else {
            dismiss();
        }
    };

    const promptRef = usePrompt({
        onAction
    });

    return <Flexer ref={promptRef}>
        <Popup w={32}>
            <Popup.Close onAction={() => onAction(false)} />
            <Popup.Title>{title ?? 'Select Location'}</Popup.Title>
            <Popup.Content>
                {label && <Copy>
                    {label}
                </Copy>}
                <TeamLocationSelectView
                    mode={mode}
                    onChange={setLocation}
                />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid} variant="primary" onAction={() => onAction(true)}>
                    {primary ?? 'Select'}
                </Button>
                <Button onAction={() => onAction(false)}>
                    Cancel
                </Button>
            </Popup.Actions>
        </Popup>
    </Flexer>;
});
